import { UnitGroupLoader } from './UnitGroupLoader';

export const unitGroupsLoader: { (token?: string): UnitGroupLoader } = (token) =>
  new UnitGroupLoader(token);
